import { blogArticles } from "./blogArticles";

const serviceEntries = [
  ["virtual-office", "Virtual Office", "/virtual-office", ["virtual address", "business address", "gst address", "apob"]],
  ["private-limited", "Private Limited Company Registration", "/private-limited-company-registration", ["pvt ltd", "private ltd", "private limited", "pvt company", "company registration", "incorporation"]],
  ["llp", "LLP Registration", "/llp-registration", ["limited liability partnership", "llp incorporation"]],
  ["trademark", "Trademark Application Assistance", "/trademark-registration", ["trade mark", "trademark registration", "brand registration", "logo registration", "tm application", "tm registration"]],
  ["proprietorship", "Proprietorship Registration", "/proprietorship-registration", ["sole proprietor", "proprietor business"]],
  ["partnership", "Partnership Firm Registration", "/partnership-registration", ["partnership deed", "firm registration"]],
  ["startup-india", "Startup India Recognition", "/startup-india-registration", ["dpiit", "startup registration"]],
  ["gst-registration", "GST Registration", "/registration/gst-registration", ["gst reg", "gstin", "gst number"]],
  ["gst-14a", "Rule 14A GST Registration", "/registration/gst-rule-14a", ["14a gst", "gst rule 14a"]],
  ["gst-amendment", "GST Amendment", "/registration/gst-amendment", ["gst change", "gst address change"]],
  ["gst-cancellation", "GST Cancellation", "/registration/gst-cancellation", ["cancel gst", "gst surrender"]],
  ["gst-revocation", "GST Revocation", "/registration/gst-revocation", ["gst restoration", "gst suspension"]],
  ["gst-filing", "GST Return Filing", "/compliance-services?package=gst#compliance-builder", ["gst filing", "gst filling", "gstr1", "gstr 1", "gstr3b", "gstr 3b"]],
  ["bookkeeping", "Accounting & Bookkeeping", "/compliance-services?package=books#compliance-builder", ["accounts", "book keeping", "monthly accounting"]],
  ["itr", "Income Tax Return Filing", "/compliance-services?package=gstItr#compliance-builder", ["itr", "income tax filing", "tax return"]],
  ["tds", "TDS Compliance", "/compliance-services#annual-add-ons", ["tds return", "tds filing"]],
  ["roc", "ROC & Annual Compliance", "/compliance-services#annual-add-ons", ["aoc 4", "mgt 7", "annual filing", "company compliance"]],
  ["udyam", "Udyam / MSME Registration", "/registration/udyam-registration", ["msme", "udyog", "udyam certificate"]],
  ["iec", "Import Export Code Registration", "/registration/iec-registration", ["import export", "export licence", "iec code"]],
  ["lut", "GST LUT Filing", "/registration/lut-registration", ["rfd 11", "export without igst"]],
  ["fssai", "FSSAI Registration / Licence", "/registration/fssai-registration", ["food licence", "food license"]],
  ["shop-act", "Shop & Establishment Registration", "/registration/shop-establishment", ["shop act", "establishment licence"]],
  ["trade-licence", "Trade Licence", "/registration/trade-license", ["trade license", "municipal licence"]],
  ["professional-tax", "Professional Tax Registration", "/registration/professional-tax", ["pt registration", "ptrc", "ptec"]],
  ["pf", "EPFO Registration", "/registration/pf-registration", ["pf registration", "provident fund", "epf"]],
  ["esi", "ESIC Registration", "/registration/esi-registration", ["esi registration", "employee state insurance"]],
  ["dsc", "Digital Signature Certificate", "/registration/digital-signature", ["digital signature", "class 3 dsc"]],
  ["opc", "One Person Company Registration", "/registration/one-person-company", ["opc", "one person company", "single person company"]],
  ["section-8", "Section 8 Company Registration", "/registration/section-8-company", ["section 8", "ngo company", "non profit company"]],
  ["producer-company", "Producer Company Registration", "/registration/producer-company", ["farmer producer company", "fpc", "producer company"]],
  ["public-limited", "Public Limited Company Registration", "/registration/public-limited-company", ["public company", "public ltd"]],
  ["nidhi-company", "Nidhi Company Registration", "/registration/nidhi-company", ["nidhi", "mutual benefit company"]],
  ["indian-subsidiary", "Indian Subsidiary Registration", "/registration/indian-subsidiary", ["foreign company india", "wholly owned subsidiary", "wos"]],
  ["iec-update", "IEC Annual Update", "/registration/iec-update", ["iec renewal", "iec confirmation", "update iec"]],
  ["ad-code", "AD Code Registration", "/registration/ad-code-registration", ["ad code", "icegate bank registration", "customs ad code"]],
  ["apeda", "APEDA e-RCMC Registration", "/registration/apeda-rcmc", ["apeda", "agri export registration", "apeda rcmc"]],
  ["export-rcmc", "Export Promotion Council RCMC", "/registration/export-rcmc", ["rcmc", "export council registration", "epc registration"]],
  ["spices-board", "Spices Board CRES Registration", "/registration/spices-board-registration", ["spice board", "cres", "spices exporter registration"]],
  ["ecommerce", "E-commerce Seller Setup", "/registration/ecommerce-seller", ["amazon seller", "flipkart seller", "online seller"]],
  ["tour-travel", "Tour & Travel Business Setup", "/registration/tour-travel-business", ["travel agency", "tour operator"]],
].map(([id, title, path, keywords]) => ({ id, title, path, keywords, type: "Service" }));

const virtualOfficeLocations = [
  ["andhra-pradesh", "Andhra Pradesh", ["vijayawada"]],
  ["arunachal-pradesh", "Arunachal Pradesh", ["itanagar"]],
  ["assam", "Assam", ["guwahati"]],
  ["bihar", "Bihar", ["patna", "bahadurpur"]],
  ["chhattisgarh", "Chhattisgarh", ["korba"]],
  ["goa", "Goa", ["panaji"]],
  ["gujarat", "Gujarat", ["ahmedabad"]],
  ["haryana", "Haryana", ["gurugram", "gurgaon"]],
  ["himachal-pradesh", "Himachal Pradesh", ["dharamshala", "kangra"]],
  ["jharkhand", "Jharkhand", ["ranchi"]],
  ["karnataka", "Karnataka", ["bengaluru", "bangalore"]],
  ["kerala", "Kerala", []],
  ["madhya-pradesh", "Madhya Pradesh", ["indore"]],
  ["maharashtra", "Maharashtra", ["mumbai", "goregaon"]],
  ["manipur", "Manipur", ["imphal"]],
  ["meghalaya", "Meghalaya", ["shillong"]],
  ["mizoram", "Mizoram", ["aizawl"]],
  ["nagaland", "Nagaland", ["dimapur"]],
  ["odisha", "Odisha", ["orissa", "bhubaneswar"]],
  ["punjab", "Punjab", []],
  ["rajasthan", "Rajasthan", ["jaipur"]],
  ["sikkim", "Sikkim", ["gangtok"]],
  ["tamil-nadu", "Tamil Nadu", ["chennai", "coimbatore"]],
  ["telangana", "Telangana", ["hyderabad"]],
  ["tripura", "Tripura", ["agartala"]],
  ["uttar-pradesh", "Uttar Pradesh", ["noida", "lucknow", "up"]],
  ["uttarakhand", "Uttarakhand", ["dehradun"]],
  ["west-bengal", "West Bengal", ["kolkata", "calcutta"]],
  ["andaman-and-nicobar-islands", "Andaman & Nicobar Islands", ["andaman nicobar", "port blair"]],
  ["chandigarh", "Chandigarh", []],
  ["dadra-and-nagar-haveli-and-daman-and-diu", "Dadra & Nagar Haveli and Daman & Diu", ["dadra nagar haveli", "daman", "diu", "silvassa"]],
  ["delhi", "Delhi", ["new delhi", "ncr"]],
  ["jammu-and-kashmir", "Jammu & Kashmir", ["jammu kashmir", "jammu", "srinagar"]],
  ["ladakh", "Ladakh", ["leh"]],
  ["lakshadweep", "Lakshadweep", []],
  ["puducherry", "Puducherry", ["pondicherry"]],
].map(([slug, name, keywords]) => ({
  id: `virtual-office-${slug}`,
  title: `Virtual Office in ${name}`,
  path: `/virtual-office/${slug}`,
  keywords: [name, ...keywords, `virtual office ${name}`],
  type: "Location",
}));

const guideEntries = [
  { id: "services", title: "All Services", path: "/services", keywords: ["service list", "services"], type: "Guide" },
  { id: "prices", title: "All Prices", path: "/all-prices", keywords: ["price", "pricing", "fees", "cost"], type: "Guide" },
  { id: "business-setup", title: "Business Setup Guide", path: "/business-setup", keywords: ["start business", "business registration"], type: "Guide" },
  { id: "compliance", title: "Compliance Services", path: "/compliance-services", keywords: ["monthly compliance", "annual compliance"], type: "Guide" },
  { id: "membership", title: "BizSarthi Business Membership", path: "/business-membership", keywords: ["membership id", "member discount", "business membership", "verify membership"], type: "Guide" },
  { id: "business-tools", title: "Business Setup Tools", path: "/business-tools", keywords: ["cost calculator", "company cost", "document checklist", "entity selector", "compliance calendar"], type: "Guide" },
  { id: "knowledge-centre", title: "BizSarthi Knowledge Centre", path: "/blog", keywords: ["blog", "articles", "business guides", "resources"], type: "Guide" },
  { id: "trust-centre", title: "BizSarthi Trust Centre", path: "/trust-centre", keywords: ["trust", "transparency", "legal identity", "cin", "company verification", "fee clarity"], type: "Guide" },
];

const articleEntries = blogArticles.map((article) => ({
  id: `article-${article.slug}`,
  title: article.title,
  path: `/blog/${article.slug}`,
  keywords: [article.category, article.excerpt, ...article.title.split(" ")],
  type: "Article",
}));

export const searchCatalog = [
  ...serviceEntries,
  ...virtualOfficeLocations,
  ...guideEntries,
  ...articleEntries,
];

const normalize = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

export const findSearchResults = (query, limit = 8) => {
  const normalizedQuery = normalize(query);
  if (!normalizedQuery) return [];
  const queryTerms = normalizedQuery.split(" ").filter(Boolean);

  return searchCatalog
    .map((item) => {
      const title = normalize(item.title);
      const aliases = item.keywords.map(normalize);
      const searchable = [title, ...aliases].join(" ");
      let score = 0;
      if (title === normalizedQuery) score += 120;
      if (aliases.includes(normalizedQuery)) score += 110;
      if (title.startsWith(normalizedQuery)) score += 80;
      if (searchable.includes(normalizedQuery)) score += 60;
      if (queryTerms.every((term) => searchable.includes(term))) score += 40;
      queryTerms.forEach((term) => {
        if (title.includes(term)) score += 8;
      });
      return { ...item, score };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score || a.title.localeCompare(b.title))
    .slice(0, limit);
};
